import _ from 'lodash'
// @ts-ignore
import DOMPurify from 'dompurify';
import { onMounted, ref, computed, nextTick } from 'vue';
import { getCurrentLanguage } from '@eureka/language-tool';
import { container } from '@eureka/services';

export interface BIChartProps {
    configTaskFunc: () => Promise<any>,
    dataTaskFunc: () => Promise<any>,
    colorFunc?: (data: any[]) => any[],
    chartKey: string,
    isLoading: boolean,
}

export function useBIChart(props: BIChartProps, emit: (event: 'click' | 'chart-loaded', ...args: any[]) => void) {
    /* data */
    const id = ref<string>('id');
    const containerClass = ref<string>(`bi-chart-${props.chartKey}__container`);
    const visualCurr = ref<any>(undefined);
    const isChartLoaded = ref(false);

    const locale = computed(() => {
        return getCurrentLanguage();
    });

    /**
     * 用于处理bi不支持的字段
     */
    function axisFn(data: any) {
        const { datasource } = data;
        const getDimensionsByCodes = datasource.getDimensionsByCodes;
        datasource.getDimensionsByCodes = async function(codes: string[], keys?: string[]) {
            const basicFieldConf = await getDimensionsByCodes.bind(datasource)(codes, keys);
            return basicFieldConf;
        };
    }

    function getConfig() {
        return props.configTaskFunc();
    }

    function getData() {
        return props.dataTaskFunc().then(data => {
            _.forEach(data?.extra, (v, k) => {
                const items = _.get(data.extra, k);
                _.forEach(items, item => {
                    if (item.label) {
                        item.label = DOMPurify.sanitize(item.label, { ALLOWED_TAGS: [] });
                    }
                })
            });
            const { dimensions = [] } = data;
            if (dimensions[dimensions.length - 1] === 'paper_count') {
                return {
                    TARGET_PAPER_COUNT: data,
                    NEW_CHART: true,
                }
            }
            return {
                TARGET_PATENT_COUNT: data,
                NEW_CHART: true,
            }
        });
    }

    function handleResize() {
        visualCurr.value?.resize?.();
    }

    async function getBase64Str() {
        try {
            const str = await visualCurr.value?.getDataURL({
                type: 'png',
                pixelRatio: 2,
                backgroundColor: '#fff',
                svgSelector: '.analysis-bi-chart .world-cloud-wrapper',
            })
            return str;
        } catch (e) {
            console.log('get base64 error:', e);
            return '';
        }
    }

    onMounted(async() => {
        const [moduleVisual, moduleCreate, { default: matrixContainer }] = await Promise.all([
            // @ts-ignore
            import('MatrixCore/Visuals'),
            // @ts-ignore
            import('MatrixCore/createVisualWithoutChartId'),
            // @ts-ignore
            import('MatrixCore/container')
        ]);

        const { Visuals } = moduleVisual.default;
        const createVisualWithoutChartId = moduleCreate.default;

        const {
            visual,
            loadDataset,
            analysisSetting,
            /* datasource, */
        } = await createVisualWithoutChartId(id.value, locale.value, {}, {
            async loadVisual(visualId: string) {
                // @ts-ignore
                const targetVisualChart = await import('MatrixCore/ChartInstances').then(res => {
                    return res.default[visualId]
                });
                Visuals.registerVisual(targetVisualChart);
                const ChartClass = await Visuals.install(visualId);
                return ChartClass;
            },
            patch() {
                matrixContainer.BiHttp.httpClient = container.RnDHttp.httpClient;
            },
        }, getData, getConfig, axisFn, 'Eureka');
        const dataset = await loadDataset('Eureka');
        //! 是否开启chart自适应，开启后小图模式，Legend会被隐藏
        visual.isChangeWithContainer = true;

        visual.renderEmpty = visual.renderError = (el: HTMLElement) => {
            visual.dispose();
            emit('chart-loaded');
            const noData = document.querySelector('.analysis-bi-chart .chart-no-data')?.cloneNode(true);
            if (noData) {
                // @ts-ignore
                noData.style.display = 'flex';
                el.appendChild(noData);
            }
        };
        visual.clickable((data: any) => {
            // @ts-ignore
            emit('click', data);
        });
        visualCurr.value = visual;
        await nextTick();

        if (_.isFunction(props.colorFunc)) {
            visual.style.colors.colors = props.colorFunc(visual.style.colors.colors);
        }
        try {
            // @ts-ignore
            await visual.trueUpdate(document.querySelector(`.${containerClass.value}`), dataset, visual.displayOptions, visual.style, analysisSetting);
        } catch (e) {
            window.console.log(e)
        } finally {
            isChartLoaded.value = true;
            emit('chart-loaded');
        }
    })

    return {
        visualCurr,
        containerClass,
        isChartLoaded,
        handleResize,
        getBase64Str,
    }
}
